// import { JSONEditor } from 'components/JSONEditor';
import { InputEditor } from 'components/InputEditor/InputEditor';
import { RequestExplorerActionTypes, RequestExplorerContext } from 'contexts/RequestExplorer';
import type { FC } from 'react';
import { useContext } from 'react';
import type { IContainerChildrenProps } from 'utils';

interface RequestBodyProps extends IContainerChildrenProps {
  locked?: boolean;
  // params: Record<string, string | number | undefined>;
  // url: string;
}
const RequestBody: FC<RequestBodyProps> = ({ locked }) => {
  const ctx = useContext(RequestExplorerContext);
  if (!ctx) {
    // eslint-disable-next-line no-console
    console.error('RequestExplorerContextProvider required');

    return <>RequestExplorerContextProvider required</>;
  }

  return (
    <InputEditor
      value={ctx?.state.body}
      disabled={locked}
      allowEmpty
      onChange={value => {
        ctx?.dispatch({
          type: RequestExplorerActionTypes.UPDATE_BODY,
          payload: value
        });
      }}
    />
  );
};

export default RequestBody;
